import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

ReactDOM.render(<App />, document.getElementById('root'))

// Register the PWA service worker. The PwaPrompt component (mounted inside
// ThemeContainer) hooks into the global `__pwaShowUpdatePrompt` callback to
// surface the "new version available" UI when the worker installs an update.
serviceWorkerRegistration.register({
  onUpdate: () => {
    if (typeof window.__pwaShowUpdatePrompt === 'function') {
      window.__pwaShowUpdatePrompt()
    }
  },
})
 